import React from 'react'
import {connect} from "react-redux";

import Windowbutton from "../gui/windowbutton";
import ModuleIcon from "./ModuleIcon";

const ModuleBox = ({_mod, gs}) => {
    return (
        <Windowbutton close={() => {
        }} headline={'Module'} id={'MD'} width={200} icon={'MD'}>
            <div style={{
                background: '#8FA198',
                position: 'absolute',
                maxHeight: '600px',
                width: 200,
                overflow: 'auto',
            }}>
                {_mod && _mod.map(it =>
                    <ModuleIcon key={it.id} mod={it}/>
                )}
            </div>
        </Windowbutton>
    )
}

function mapStateToProps(state, other) {

    const ret = state.plan.items ? state.plan.items.filter(
        it => it.typename === "module" && it.scenario === other.scenario
    ) : []

    return {_mod: ret}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleBox)
